import type React from 'react';
import styled, { useTheme } from 'styled-components';
import { useIntl } from 'react-intl';

import Typography from 'app/ui/components/atoms/typography';
import ActionCard from 'src/app/ui/components/molecules/gradient-action-card';
import conceptWorkoutIcon from 'app/assets/concept-workout.svg';

const ArchiveArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  gap: 2.5rem;
  margin-bottom: 4rem;
`;

const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  align-items: stretch;

  ${({ theme: { media } }) => `
    ${media.medium(
      () => `
        grid-template-columns: repeat(2, 1fr);
      `,
    )}
  `}
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
`;

const PageTitle = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

const WorkoutArchive: React.FC = () => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <ArchiveArea>
      <TitleWrapper>
        <PageTitle variant="h3" color={theme.colors.white}>
          {intl.formatMessage({ id: 'library.workoutArchive' })}
        </PageTitle>
        <Typography variant="body2" color={theme.colors.lightGray}>
          {intl.formatMessage({ id: 'library.workoutArchiveCopy' })}
        </Typography>
      </TitleWrapper>
      <CardWrapper>
        <ActionCard
          title={intl.formatMessage({ id: 'library.conceptWorkouts' })}
          shortDescription={intl.formatMessage({ id: 'library.conceptWorkoutsCopy' })}
          ctaImageUrl={conceptWorkoutIcon}
          to="/browse"
        />
      </CardWrapper>
    </ArchiveArea>
  );
};

export default WorkoutArchive;
